"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _feAllhomesLibrary = require("@domain-group/fe-allhomes-library");
var _feCoAvatar = _interopRequireDefault(require("@domain-group/fe-co-avatar"));
var _bed = _interopRequireDefault(require("@domain-group/fe-co-icon/lib/js/bed"));
var _bath = _interopRequireDefault(require("@domain-group/fe-co-icon/lib/js/bath"));
var _parking = _interopRequireDefault(require("@domain-group/fe-co-icon/lib/js/parking"));
var _listing = _interopRequireDefault(require("../../models/listing"));
var styles = _interopRequireWildcard(require("./small-card.style"));
var _core = require("@emotion/core");
var _excluded = ["listing"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SmallCard = _ref => {
  var listing = _ref.listing,
    props = _objectWithoutProperties(_ref, _excluded);
  var renderFeature = (SelectedIcon, title, featureValue) => {
    if (featureValue) {
      return (0, _core.jsx)("span", {
        css: styles.feature
      }, (0, _core.jsx)("span", null, featureValue), (0, _core.jsx)(SelectedIcon, {
        title: title,
        size: "small"
      }));
    }
    return false;
  };
  var displayStreet = () => {
    if (listing.newDevelopment && listing.propertyName) {
      return "".concat(listing.propertyName, ",");
    }
    if (listing.address.street && listing.address.street.length > 0) {
      return "".concat(listing.address.street, ",");
    }
    return (0, _core.jsx)(_react.Fragment, null, "\xA0");
  };
  return (0, _core.jsx)("div", {
    css: styles.listingCard
  }, (0, _core.jsx)("img", {
    css: styles.image,
    src: (0, _feAllhomesLibrary.getImageUrl)(listing.image.highRes, _feAllhomesLibrary.ListingImageSizes.MEDIUM),
    alt: ""
  }), (0, _core.jsx)("div", {
    css: styles.infoSection
  }, (0, _core.jsx)("div", {
    css: styles.listingInfo
  }, (0, _core.jsx)("span", {
    css: styles.price
  }, listing.formattedPrice), (0, _core.jsx)("a", {
    href: listing.url,
    css: styles.addressContainer,
    onClick: props.onClick
  }, (0, _core.jsx)("span", {
    css: styles.addressLine
  }, displayStreet()), (0, _core.jsx)("span", {
    css: styles.addressLine
  }, listing.address.suburb, " ", listing.address.state, ' ', listing.address.postcode)), (0, _core.jsx)("div", {
    css: styles.featureGroup
  }, renderFeature(_bed.default, 'Bedrooms', listing.formattedBeds), renderFeature(_bath.default, 'Bathrooms', listing.formattedBaths), renderFeature(_parking.default, 'Parking', listing.formattedParking))), (0, _core.jsx)("div", {
    css: styles.agentInfo
  }, (0, _core.jsx)(_feCoAvatar.default, {
    css: styles.agentPhoto,
    imageUrl: listing.agent.agentPhoto,
    isBordered: true,
    colorScheme: "light",
    size: "small"
  }), (0, _core.jsx)("img", {
    src: listing.agent.agencyLogo,
    css: styles.agencyLogo,
    alt: ""
  }))));
};
SmallCard.propTypes = {
  listing: _propTypes.default.shape(_listing.default).isRequired,
  onClick: _propTypes.default.func
};
SmallCard.defaultProps = {
  onClick: () => {}
};
var _default = exports.default = SmallCard;